import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@progress/kendo-theme-default/dist/default-ocean-blue-a11y.css";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <App />
);